import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Button } from "./ui/button";
import { Mail, Loader2, CalendarClock } from "lucide-react";
import { toast } from "sonner";

const Tile = ({ label, value, tid, accent }) => (
  <div className="rounded-lg bg-[#131722] px-3 py-2 min-w-0" data-testid={tid}><p className={`font-mono text-lg leading-none ${accent || "text-slate-100"}`}>{value}</p><p className="text-[10px] text-slate-500 mt-1 truncate">{label}</p></div>
);

export default function DigestSummaryCard() {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => api.get("/admin/owner-digest/summary").then((r) => setData(r.data)).catch(() => setData(false)), []);
  useEffect(() => { load(); }, [load]);
  if (!data) return null;
  const { live, last, next_send: next } = data;
  const sendNow = async () => { setBusy(true); try { await api.post("/admin/owner-digest/send"); toast.success("Digest sent to your inbox"); load(); } catch { toast.error("Could not send"); } finally { setBusy(false); } };
  return (
    <section className="rounded-2xl border border-slate-800 bg-[#0B0D12] p-4 mb-8 rise rise-1" data-testid="digest-summary-card">
      <div className="flex items-start justify-between gap-2 mb-3">
        <div className="min-w-0"><p className="font-semibold text-sm inline-flex items-center gap-1.5"><Mail className="w-4 h-4 text-cyan-300" />Owner digest</p>
          <p className="text-[11px] text-slate-500 inline-flex items-center gap-1 mt-0.5" data-testid="digest-next-send"><CalendarClock className="w-3 h-3" />Next {new Date(next).toLocaleString([], { weekday: "short", hour: "numeric", minute: "2-digit" })}{last ? ` · last ${new Date(last.sent_at).toLocaleDateString()}` : " · never sent"}</p></div>
        <Button size="sm" variant="outline" onClick={sendNow} disabled={busy} className="h-8 border-slate-700 text-xs shrink-0" data-testid="digest-card-send">{busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : "Send now"}</Button>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-5 gap-2">
        <Tile label="Cars to sell" value={live.to_sell} tid="digest-tile-to-sell" accent={live.to_sell ? "text-amber-300" : undefined} />
        <Tile label="Open offers" value={live.offers} tid="digest-tile-offers" />
        <Tile label="Beat break-even" value={live.winners} tid="digest-tile-winners" accent={live.winners ? "text-emerald-300" : undefined} />
        <Tile label="Closings 7d" value={live.closings} tid="digest-tile-closings" />
        <Tile label="Investor msgs" value={live.unread} tid="digest-tile-unread" accent={live.unread ? "text-cyan-300" : undefined} />
      </div>
      <Link to="/admin?tab=investors" className="text-[11px] text-cyan-300 hover:underline mt-2 inline-block" data-testid="digest-card-open">Open Investors tab →</Link>
    </section>
  );
}
